<template>
  <div class="i-cell-value">
    {{ dateString }}
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { formatDateLocale } from '@/utils/tools';

export default defineComponent({
  inheritAttrs: false,
  props: {
    item: Object,
    column: String,
  },
  computed: {
    ...mapState(['LANG', 'locale']),
    dateString() {
      const timestamp = Number(this.item[this.column]);
      if (!timestamp) return '';

      return formatDateLocale(timestamp, this.locale);
    },
  },
});
</script>

<style scoped lang='scss'>
</style>
